export function createSelect (values, t) {
  return values.map((value) => { return { label: t(`${value}`).s, value } })
}
